import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pureFilter',
    standalone: false
})
export class PureFilterPipe<T> implements PipeTransform {

  transform(values: T[], filterFn: (value: T, index: number, array: T[]) => boolean): any {
    return values ? values.filter(filterFn) : values;
  }

}
